// extracted by mini-css-extract-plugin
export default {"TwoDimsFeature":"wg_a bhr_b bhr_we"};